import type { ReactNode } from "react";

import { Text, View, type ViewStyle } from "react-native";

export function VisuallyHidden({ children }: { children: ReactNode }): React.JSX.Element {
  // Tested on Samsung Galaxy, Google Pixel (Android), and iPhone (iOS) devices.
  // These specific values ensure content is hidden visually but remains
  // accessible to actual screen readers.  Lower settings removed the content
  // from the accessible tree.
  // - opacity: 0.00000001 (near-zero but not zero to remain in accessibility tree)
  // - height: 8, width: 1 (minimal dimensions to satisfy layout requirements)
  // - overflow: 'hidden' (prevents content from rendering visibly)
  // - pointerEvents: 'none' (prevents interaction)

  const style: ViewStyle = {
    opacity: 0.00000001,
    overflow: "hidden",
    pointerEvents: "none",
    height: 8,
    width: 1,
  };
  return (
    <View style={style} accessibilityElementsHidden={false}>
      <Text>{children}</Text>
    </View>
  );
}
